export const GET_TIMESLOTS_REQUEST = 'GET_TIMESLOTS_REQUEST';
export const GET_TIMESLOT_SUCCESS = 'GET_TIMESLOT_SUCCESS';
export const GET_TIMESLOT_FAILURE = 'GET_TIMESLOT_FAILURE';

export const EDIT_TIMESLOT = 'EDIT_TIMESLOT';
export const SAVE_TIMESLOT_REQUEST = 'SAVE_TIMESLOT_REQUEST';
export const SAVE_TIMESLOT_SUCCESS = 'SAVE_TIMESLOT_SUCCESS';
export const SAVE_TIMESLOT_FAILURE = 'SAVE_TIMESLOT_FAILURE';

export const DELETE_TIMESLOT_REQUEST = 'DELETE_TIMESLOT_REQUEST';
export const DELETE_TIMESLOT_SUCCESS = 'DELETE_TIMESLOT_SUCCESS';
export const DELETE_TIMESLOT_FAILURE = 'DELETE_TIMESLOT_FAILURE';



// WEBPACK FOOTER //
// ./src/store/modules/timeslots/mutation-types.js